export default "__VITE_ASSET__vZwqK5Uj__"